<template>
  <div class="signage-layout">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "signage",
};
</script>